import { format, isValid, parse, parseISO } from "date-fns";

const CANDIDATE_FORMATS = [
  "yyyy-MM-dd",
  "M/d/yyyy",
  "MM/dd/yyyy",
  "M/d/yy",
  "MM/dd/yy",
  "yyyy/M/d",
  "yyyy/MM/dd",
  "MM-dd-yyyy",
  "M-d-yyyy",
  "MMddyyyy",
];

function isPlausibleBirthDate(d) {
  if (!isValid(d)) return false;
  const now = new Date();
  if (d > now) return false;
  const minYear = 1900;
  if (d.getFullYear() < minYear) return false;
  return true;
}

/**
 * Parse free-text DOB into ISO yyyy-MM-dd. Assumes US date order (M/D/Y) for ambiguous input.
 * @returns {{ ok: true, iso: string, date: Date } | { ok: false, error: string }}
 */
export function parseFlexibleDob(input) {
  const trimmed = (input || "").trim();
  if (!trimmed) {
    return { ok: false, error: "Enter your date of birth." };
  }

  const strictIso = parseISO(trimmed);
  if (isValid(strictIso) && isPlausibleBirthDate(strictIso)) {
    return { ok: true, iso: format(strictIso, "yyyy-MM-dd"), date: strictIso };
  }

  for (const fmt of CANDIDATE_FORMATS) {
    const ref = new Date();
    const d = parse(trimmed, fmt, ref);
    if (isValid(d) && isPlausibleBirthDate(d)) {
      return { ok: true, iso: format(d, "yyyy-MM-dd"), date: d };
    }
  }

  if (/^\d{8}$/.test(trimmed)) {
    const d8 = parse(trimmed, "MMddyyyy", new Date());
    if (isValid(d8) && isPlausibleBirthDate(d8)) {
      return { ok: true, iso: format(d8, "yyyy-MM-dd"), date: d8 };
    }
  }

  const nat = new Date(trimmed);
  if (isValid(nat) && !Number.isNaN(nat.getTime()) && isPlausibleBirthDate(nat)) {
    return { ok: true, iso: format(nat, "yyyy-MM-dd"), date: nat };
  }

  return {
    ok: false,
    error:
      "We could not read that date. Use MM/DD/YYYY (for example 3/5/2001) or pick a date below.",
  };
}

/**
 * @param {string} iso - yyyy-MM-dd
 */
export function formatDobForDisplay(iso) {
  if (!iso) return "";
  const [yyyy, mm, dd] = iso.split("-");
  if (!yyyy || !mm || !dd) return iso;
  return `${parseInt(mm, 10)}/${parseInt(dd, 10)}/${yyyy}`;
}
